import React from 'react';
import { Mail, Github, MessageCircle } from 'lucide-react';
import { personalInfo } from '../../data/personal';

// SVG icons for social media platforms
const GitlabIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.955 13.587l-1.342-4.135-2.664-8.189c-.135-.423-.73-.423-.867 0L16.418 9.45H7.582L4.919 1.263c-.135-.423-.73-.423-.867 0L1.388 9.452.045 13.587c-.121.375.014.789.331 1.023L12 23.054l11.624-8.443c.318-.235.452-.648.331-1.024"/>
  </svg>
);

const BehanceIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.498 1.19.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.76-.62.16-1.95.24-2.21.24H0V4.51h6.938v-.007zM16.94 16.665c.44.428 1.073.643 1.894.643.59 0 1.1-.148 1.53-.447.424-.29.68-.61.78-.94h2.588c-.403 1.28-1.048 2.2-1.9 2.75-.85.56-1.884.83-3.08.83-.837 0-1.584-.13-2.272-.4-.673-.27-1.24-.65-1.72-1.14-.464-.49-.823-1.08-1.077-1.77-.253-.69-.373-1.45-.373-2.27 0-.803.135-1.54.403-2.23.27-.7.644-1.28 1.12-1.79.495-.51 1.063-.9 1.736-1.194.673-.294 1.41-.44 2.215-.44.867 0 1.622.16 2.268.48.645.32 1.177.74 1.6 1.26.42.52.709 1.11.87 1.77.16.66.22 1.36.18 2.1h-7.69c.036.82.27 1.49.71 1.91l.001.002zm-10.24.05c.317 0 .62-.03.906-.093.29-.06.548-.165.763-.3.21-.135.39-.328.52-.583.13-.24.19-.57.19-.96 0-.75-.22-1.29-.64-1.62-.43-.32-.99-.48-1.69-.48H3.24v4.05H6.7v-.03zm13.607-5.65c-.352-.385-.94-.578-1.77-.578-.48 0-.87.12-1.17.37-.305.24-.49.55-.554.94h4.62c-.063-.76-.174-1.31-.525-1.73h-.6zm-13.61-6.218c.26 0 .514.022.765.07.25.09.464.207.628.35.163.14.28.34.35.59.07.24.10.43.10.69 0 .26-.05.49-.15.69-.1.2-.25.36-.44.49-.19.13-.42.22-.67.27-.25.05-.54.07-.84.07H3.23v-3.2h3.47-.01z"/>
    </svg>
);
const FacebookIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-32 min-h-screen flex items-center">
      <div className="max-w-6xl mx-auto px-4 text-center w-full">
        <h2 className="spotlight inline-block text-3xl sm:text-4xl md:text-5xl font-bold mb-8 pb-2 leading-tight bg-gradient-to-r from-emerald-400 to-gold-400 bg-clip-text text-transparent animate-fade-in-up">
          Let's Work Together
        </h2>
        <p className="text-lg sm:text-xl text-slate-300 mb-16 animate-fade-in-up max-w-3xl mx-auto"
           style={{animationDelay: '0.2s'}}>
          Ready to build scalable software solutions? Let's collaborate on backends,
          APIs, or mobile applications that deliver real impact.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <a
              href="https://wa.me/+963996697253"
              target="_blank"
              rel="noopener noreferrer"
              className="lit-card rounded-2xl p-8 transition-all duration-300 transform hover:-translate-y-1.5 animate-fade-in-up cursor-pointer"
              style={{animationDelay: '0.4s'}}
          >
            <MessageCircle
                className="w-10 h-10 text-green-400 mx-auto mb-6 animate-float drop-shadow-[0_0_12px_rgba(74,222,128,0.5)]"/>
            <h3 className="text-xl font-semibold mb-4">WhatsApp</h3>
            <span className="text-slate-300 text-lg">+963 996 697 253</span>
          </a>

          <a
              href={`mailto:${personalInfo.email}`}
              className="lit-card rounded-2xl p-8 transition-all duration-300 transform hover:-translate-y-1.5 animate-fade-in-up cursor-pointer"
              style={{animationDelay: '0.5s'}}
          >
            <Mail
                className="w-10 h-10 text-emerald-400 mx-auto mb-6 animate-float drop-shadow-[0_0_12px_rgba(16,185,129,0.5)]"/>
            <h3 className="text-xl font-semibold mb-4">Email</h3>
            <span className="text-slate-300 text-lg">{personalInfo.email}</span>
          </a>

          <a
              href={`tel:${personalInfo.phone}`}
              className="lit-card lit-card-gold rounded-2xl p-8 transition-all duration-300 transform hover:-translate-y-1.5 animate-fade-in-up cursor-pointer"
              style={{animationDelay: '0.6s'}}
          >
            <svg className="w-10 h-10 text-gold-400 mx-auto mb-6 animate-float drop-shadow-[0_0_12px_rgba(212,175,55,0.5)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <h3 className="text-xl font-semibold mb-4">Phone</h3>
            <span className="text-slate-300 text-lg">{personalInfo.phone}</span>
          </a>
        </div>
        <div className="lit-card rounded-2xl p-8 mb-20 animate-fade-in-up"
             style={{animationDelay: '1.1s'}}>
          <h3 className="text-xl font-bold mb-4 text-white">Ready to Start Your Project?</h3>
          <p className="text-slate-300 mb-6 max-w-2xl mx-auto">
            I'm always excited to take on new challenges and collaborate on innovative mobile solutions.
            Let's discuss how we can bring your vision to life.
          </p>
          <a
              href="https://wa.me/+963996697253"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center px-8 py-4 rounded-full font-semibold transform hover:scale-[1.03]"
          >
            Get In Touch
          </a>
        </div>
        <div>
          <h3 className="text-2xl font-bold mb-8 text-white animate-fade-in-up" style={{animationDelay: '0.6s'}}>
            Follow Me On
          </h3>
          <div className="flex justify-center items-center space-x-8 flex-wrap gap-y-6">
            <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center group animate-fade-in-up"
                style={{animationDelay: '0.7s'}}
            >
              <div
                  className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center hover:bg-gray-700 transition-all duration-300 transform hover:scale-110 group-hover:shadow-lg group-hover:shadow-gray-500/25">
                <Github className="w-8 h-8"/>
              </div>
              <span
                  className="mt-3 text-sm font-medium text-slate-300 group-hover:text-white transition-colors">GitHub</span>
            </a>

            {personalInfo.gitlab && (
                <a
                    href={personalInfo.gitlab}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center group animate-fade-in-up"
                    style={{animationDelay: '0.8s'}}
                >
                  <div
                      className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-600 transition-all duration-300 transform hover:scale-110 group-hover:shadow-lg group-hover:shadow-orange-500/25">
                    <GitlabIcon/>
                  </div>
                  <span
                      className="mt-3 text-sm font-medium text-slate-300 group-hover:text-white transition-colors">GitLab</span>
                </a>
            )}

            {personalInfo.behance && (
                <a
                    href={personalInfo.behance}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center group animate-fade-in-up"
                    style={{animationDelay: '0.95s'}}
                >
                  <div
                      className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-all duration-300 transform hover:scale-110 group-hover:shadow-lg group-hover:shadow-emerald-500/25">
                    <BehanceIcon/>
                  </div>
                  <span
                      className="mt-3 text-sm font-medium text-slate-300 group-hover:text-white transition-colors">Behance</span>
                </a>
            )}

            {personalInfo.facebook && (
                <a
                    href={personalInfo.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center group animate-fade-in-up"
                    style={{animationDelay: '0.9s'}}
                >
                  <div
                      className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-all duration-300 transform hover:scale-110 group-hover:shadow-lg group-hover:shadow-emerald-500/25">
                    <FacebookIcon/>
                  </div>
                  <span
                      className="mt-3 text-sm font-medium text-slate-300 group-hover:text-white transition-colors">Facebook</span>
                </a>
            )}

            {personalInfo.instagram && (
                <a
                    href={personalInfo.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center group animate-fade-in-up"
                    style={{animationDelay: '1.0s'}}
                >
                  <div
                      className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center hover:bg-gradient-to-br hover:from-gold-600 hover:to-gold-600 transition-all duration-300 transform hover:scale-110 group-hover:shadow-lg group-hover:shadow-gold-500/25">
                    <InstagramIcon/>
                  </div>
                  <span
                      className="mt-3 text-sm font-medium text-slate-300 group-hover:text-white transition-colors">Instagram</span>
                </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;